import * as actions from '../actions/types'

const initialState = {
  transferOption: false,
  hsOrGED: false,
  veteran: false
};

function updatePTRequirementsInfo(ptRequirementsState, action){
  return {
    ...ptRequirementsState,
    ...action.updates
  };
}

function setPTRequirementsInfo(ptRequirementsState, action){
  return {
    ...action.application.ptRequirements
  }
}

function applicationDeleted() {
  return initialState;
}

export const ptRequirementsInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_APPLICATION:
    case actions.REFRESH_APPLICATION:
      return setPTRequirementsInfo(state, action);
    case actions.UPDATE_PT_REQUIREMENTS_INFO: return updatePTRequirementsInfo(state, action);
    case actions.DELETE_APPLICATION_SUCCESS: return applicationDeleted(state, action);
    default: return state;
  }
};

export default ptRequirementsInfoReducer;